import { combineReducers } from "redux"; //eslint-disable-line
import app from "./app";
import user from "./user";
export default combineReducers({
  user,
  app,
});
